import React, { FunctionComponent } from 'react';
import type { Industry } from '../../../types/recruitmentShow';

type Props = {
  name: string;
  jugyoinsu: string;
  shihonkin: string;
  setsuritsunengetsu: string;
  daihyoshaname: string;
  honshashozaichi: string;
  industries: Industry[];
};

export const Presentation: FunctionComponent<Props> = ({
  name,
  jugyoinsu,
  shihonkin,
  setsuritsunengetsu,
  daihyoshaname,
  honshashozaichi,
  industries,
}) => {
  const isLast = (array: any[], target: any) => {
    return array.indexOf(target) === array.length - 1
  }

  return (
    <>
      <div className="recruitment__show__content__item">
        <h3 className="subTitle">会社名・団体名</h3>
        <span>{name}</span>
      </div>

      {jugyoinsu !== '' && jugyoinsu !== null && (
        <div className="recruitment__show__content__item">
          <h3 className="subTitle">従業員数</h3>
          <span>{jugyoinsu}</span>
        </div>
      )}

      {shihonkin !== '' && shihonkin !== null && (
        <div className="recruitment__show__content__item">
          <h3 className="subTitle">資本金</h3>
          <span>{shihonkin}</span>
        </div>
      )}

      {setsuritsunengetsu !== '' && setsuritsunengetsu !== null && (
        <div className="recruitment__show__content__item">
          <h3 className="subTitle">設立年月</h3>
          <span>{setsuritsunengetsu}</span>
        </div>
      )}

      {daihyoshaname !== '' && daihyoshaname !== null && (
        <div className="recruitment__show__content__item">
          <h3 className="subTitle">代表者氏名</h3>
          <span>{daihyoshaname}</span>
        </div>
      )}

      {honshashozaichi !== '' && honshashozaichi !== null && (
        <div className="recruitment__show__content__item">
          <h3 className="subTitle">本社所在地</h3>
          <span>{honshashozaichi}</span>
        </div>
      )}

      {industries.length > 0 && (
        <div className="recruitment__show__content__item">
          <h3 className="subTitle">業種</h3>
          {industries.map((industry) => (
            <React.Fragment key={industry.enName}>
              <span className="welfare">{industry.jpName}</span>
              {!isLast(industries, industry) && (
                <strong className="devide">&nbsp;/&nbsp;</strong>
              )}
            </React.Fragment>
          ))}
        </div>
      )}
    </>
  );
};
